export default __webpack_public_path__ + "static/media/ParceirosRJ.6a75648e.png";